/* eslint-disable no-debugger */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useMemo } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { path } from 'ramda'
import { ProgressIndicator } from '@veneer/core'

import Error from '../assets/common/icons/Error'
import { ConnectionDefines, ConnectErrors } from '../constants/Options'

const Cover = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
`

const ProgressContent = styled.div`
  width: 450px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`

const Title = styled.div`
  color: var(--light-foreground, #212121);
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
`

const Desc = styled.div`
  color: var(--light-foreground, #212121);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-top: 20px;
`

const ProgressLine = styled.div`
  margin-top: 50px;
`

const ErrorCover = styled(Cover)`
  &.dialog {
    background-color: var(--light-foreground-light, #737373);
  }

  &.full {
    background-color: var(--light-foreground, #212121);
  }
`

const ErrorCard = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  width: 480px;
  padding: 32px 40px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;

  ${ErrorCover}.full & {
    background-color: transparent;
  }
`

const ErrorTitle = styled.div`
  color: var(--light-foreground, #212121);
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;

  ${ErrorCover}.full & {
    color: #fff;
  }
`

const ErrorDetail = styled.div`
  margin-top: 20px;
  color: var(--light-foreground, #212121);
  ${ErrorCover}.full & {
    color: var(--light-foreground-inverse, #fff);
  }
`

const Content = styled.div`
  margin-top: 20px;
`

const TipPanel = styled.div`
  background: rgba(190, 19, 19, 0.1);
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  ${ErrorCover}.full & {
    background: var(--light-background, #f8f8f8);
  }
`

// const TipTitle = styled.div`
//   font-size: 16px;
//   line-height: 20px;
//   color: #212121;
// `

const TipContent = styled.div`
  font-size: 12px;
  color: #404040;
  ${ErrorCover}.full & {
    color: var(--light-foreground, #212121);
  }
`

const ErrorActions = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

const ActionButton = styled.label`
  display: inline-flex;
  border-radius: 8px;
  padding: 5px 20px;
  cursor: pointer;

  &:not(:last-child) {
    margin-right: 10px;
  }
`

const RetryButton = styled(ActionButton)`
  border: 1px solid var(--light-primary, #0278ab);
  background: var(--light-primary, #0278ab);
  color: var(--light-primary, #ffffff);
`

const CloseButton = styled(ActionButton)`
  border: 1px solid var(--light-primary, #0278ab);
  background: var(--light-primary, #ffffff);
  color: var(--light-primary, #0278ab);
`

// eslint-disable-next-line react/prop-types
const ErrorView = ({ error, onRetry, onClose, onAction }) => {
  const errorDefine = error && ConnectErrors[error]
  const { title, tips, model, describe, actions } = errorDefine

  const { message, icon: Icon } = tips

  return (
    <ErrorCover onMouseMove={onAction} className={model || 'dialog'}>
      <ErrorCard>
        <ErrorTitle>{title}</ErrorTitle>
        {describe && <ErrorDetail>{describe}</ErrorDetail>}
        <Content>
          <TipPanel>
            <Icon />
            <div style={{ marginLeft: '10px' }}>
              <TipContent>{message}</TipContent>
            </div>
          </TipPanel>
        </Content>
        {actions && (
          <ErrorActions>
            <RetryButton onClick={onRetry}>Retry</RetryButton>
            <CloseButton onClick={onClose}>Close</CloseButton>
          </ErrorActions>
        )}
      </ErrorCard>
    </ErrorCover>
  )
}

const View = ({ step, error, onRetry, onClose, onAction }) => {
  console.log('rendering ConnectionStatus')

  if (error) {
    return <ErrorView error={error} onRetry={onRetry} onClose={onClose} onAction={onAction} />
  }

  const status = ConnectionDefines[step || 'connection_to_signal']
  const { name, describe } = status

  return (
    <Cover>
      <ProgressContent>
        <Title>{name}</Title>
        <Desc>{describe}</Desc>
        <ProgressLine>
          <ProgressIndicator appearance="linear" behavior="indeterminate" delay={400} />
        </ProgressLine>
      </ProgressContent>
    </Cover>
  )
}

View.defaultProps = {
  onRetry: () => {},
  onClose: () => {},
  onAction: () => {},
  step: 'connection_to_signal',
  error: null,
}

View.propTypes = {
  step: PropTypes.string,
  error: PropTypes.string,
  onClose: PropTypes.func,
  onRetry: PropTypes.func,
  onAction: PropTypes.func,
}

export default View
